import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e30ba0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cache",
  ref: "msgInfoRef"
}
const _hoisted_2 = { class: "cache_top" }
const _hoisted_3 = { class: "cache_top_left" }
const _hoisted_4 = {
  key: 0,
  class: "dialog"
}
const _hoisted_5 = { class: "file_name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file_title" }, "文件正在上传中...", -1))
const _hoisted_7 = { class: "cache_operate_right" }
const _hoisted_8 = { class: "liveList" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "operation_box" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "liveList_pagination" }
const _hoisted_15 = { class: "preview_prompt" }
const _hoisted_16 = { class: "prompt_img" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_c_del_modal = _resolveComponent("c-del-modal")!
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_range_picker, {
          ranges: {
            今天: [_ctx.moment().startOf('day'), _ctx.moment().endOf('day')],
            最近一周: [_ctx.moment().startOf('day').subtract(1, 'weeks'), _ctx.moment()],
            最近一月: [_ctx.moment().startOf('day').subtract(1, 'months'), _ctx.moment()],
            最近三月: [_ctx.moment().startOf('day').subtract(3, 'months'), _ctx.moment()],
          },
          onChange: _ctx.trigger,
          value: _ctx.queryForms,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryForms) = $event)),
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          class: "mod_range_picker file_outlined"
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["ranges", "onChange", "value"]),
        _createVNode(_component_a_input_search, {
          value: _ctx.obj.search,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.obj.search) = $event)),
          placeholder: "请输入关键字",
          "enter-button": "",
          class: "mod_range_picker_search file_outlined",
          onSearch: _ctx.trigger
        }, null, 8, ["value", "onSearch"]),
        _createVNode(_component_a_upload, {
          "file-list": _ctx.fileList,
          "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileList) = $event)),
          name: "file",
          multiple: true,
          headers: { token: _ctx.token },
          action: "/api/v1/tc_cos/tc_upload",
          onChange: _ctx.handleChange,
          showUploadList: false,
          accept: ".ppt, .pptx, .pdf"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { class: "mod_btn mod_btn_primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_upload_outlined),
                _createTextVNode("上传文档 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list", "headers", "onChange"])
      ]),
      (_ctx.isUploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"]),
              _hoisted_6
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_checkbox, {
          class: "checkbox",
          checked: _ctx.checked_all,
          "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked_all) = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSelectAll()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_button, {
          type: "link",
          danger: "",
          disabled: _ctx.selectedRowKeys.length == 0,
          onClick: _ctx.openDelModal
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_c_del_modal, {
          visible: _ctx.modal2Visible,
          centered: "",
          close: _ctx.openDelModat,
          ok: _ctx.removeLiveData
        }, {
          title: _withCtx(() => [
            _createTextVNode("此操作将删除该文件，是否继续？")
          ]),
          _: 1
        }, 8, ["visible", "close", "ok"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_a_table, {
        loading: _ctx.showLoading,
        "row-selection": _ctx.rowSelection,
        columns: _ctx.columns,
        "data-source": _ctx.datafol,
        pagination: false,
        class: "liveList_w",
        rowKey: 
          (res) => {
            return res.id;
          }
        
      }, {
        computer_type: _withCtx(({ record }) => [
          (record.computer_name.substring(record.computer_name.lastIndexOf('.') + 1) === 'pdf')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.documentPdf,
                class: "img_w"
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.documentPpt,
                class: "img_w"
              }, null, 8, _hoisted_10))
        ]),
        img: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_button, {
              type: "link",
              class: "prev_but",
              onClick: ($event: any) => (record.status != '转码中' ? _ctx.previewsImg(record) : '')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  "icon-class": "preview",
                  class: _normalizeClass(["img_ww preview", record.status == '转码中' ? 'disabled' : ''])
                }, null, 8, ["class"])
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.delDocument(record)),
              class: "prev_but"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  "icon-class": "document",
                  class: "preview"
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        status: _withCtx(({ record }) => [
          (record.err_msg === '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(record.status), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _createTextVNode("转码失败 "),
                _createVNode(_component_a_popover, { placement: "right" }, {
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.err_msg), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_ExclamationCircleFilled)
                  ]),
                  _: 2
                }, 1024)
              ]))
        ]),
        _: 1
      }, 8, ["loading", "row-selection", "columns", "data-source", "rowKey"]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_a_pagination, {
          "show-quick-jumper": "",
          total: _ctx.pageConfig.totalSize,
          current: _ctx.pageConfig.current,
          "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageConfig.current) = $event)),
          "page-size": _ctx.pageConfig.pageSize,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageConfig.pageSize) = $event)),
          pageSizeOptions: _ctx.pageConfig.options,
          "show-less-items": "",
          onChange: _ctx.mediaFileList,
          onShowSizeChange: _ctx.mediaFileList,
          "show-size-changer": "",
          class: "pagination"
        }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_c_del_modal, {
        visible: _ctx.modal2Visible,
        centered: "",
        close: _ctx.openDelModat,
        ok: _ctx.removeLiveData
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将删除该文件，是否继续？")
        ]),
        _: 1
      }, 8, ["visible", "close", "ok"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_a_modal, {
        visible: _ctx.previews,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.previews) = $event)),
        title: _ctx.datas,
        centered: true,
        onOk: _ctx.handPreview,
        width: 800,
        footer: null,
        getContainer: () => _ctx.msgInfoRef
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUrls, (img, index) => {
              return (_openBlock(), _createElementBlock("img", {
                class: "img",
                key: index,
                src: img
              }, null, 8, _hoisted_17))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk", "getContainer"])
    ])
  ], 512))
}